import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import EnrollmentFeesSection from '@/components/EnrollmentFeesSection';

// ADM-12: thin wrapper around EnrollmentFeesSection so the list-page quick-enroll
// flow shares the exact same fee/discount/installment/payment logic as the inline
// "Enrollment & Fees" card on the student profile (LeadDetailPage) — no more
// separate implementation to drift out of sync. Radix unmounts DialogContent's
// children when the dialog is closed, so EnrollmentFeesSection gets a fresh mount
// (fresh form state, fresh invoice lookup) every time this dialog opens.
export default function EnrollStudentDialog({ open, onOpenChange, lead, onEnrolled }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-xl max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="enroll-student-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-foreground text-lg">Enroll Student</DialogTitle>
        </DialogHeader>
        {lead && (
          <p className="text-sm font-semibold text-foreground -mt-2" data-testid="enroll-dialog-student-name">
            {lead.student_name}
          </p>
        )}
        <EnrollmentFeesSection
          lead={lead}
          onEnrolled={() => { onEnrolled?.(); onOpenChange(false); }}
          showCourseInterest={false}
        />
      </DialogContent>
    </Dialog>
  );
}
